import * as a from "react";
const e = (l) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M2.65 14.917H9.61a.417.417 0 00.4-.292 6.666 6.666 0 016.375-4.708 6.609 6.609 0 014.066 1.391.416.416 0 00.475 0 .434.434 0 00.192-.433l-.592-3.142a.417.417 0 00-.408-.341H3.892a.417.417 0 00-.408.341L2.242 14.4a.467.467 0 00.23.464c.055.03.116.048.178.053zM9.718 16.583v-.391a.392.392 0 00-.117-.309.401.401 0 00-.3-.133H2.418a.417.417 0 00-.417.417v2.708a1.883 1.883 0 001.883 1.875.2.2 0 01.2.208v.417a.633.633 0 00.634.625.625.625 0 00.616-.625v-.208a.417.417 0 01.417-.417h4.625a.425.425 0 00.422-.43.434.434 0 00-.055-.212 6.533 6.533 0 01-1.025-3.525zM4.084 6.584h1.317a.417.417 0 00.408-.35l.309-1.8a.417.417 0 01.408-.35h3.808a.417.417 0 01.417.417v1.667a.417.417 0 00.417.416h1.666a.417.417 0 00.417-.416V4.5a.417.417 0 01.417-.417h3.816a.417.417 0 01.409.35l.308 1.8a.417.417 0 00.408.35h1.309a.417.417 0 00.416-.416V3.876a1.867 1.867 0 00-1.866-1.875H5.55a1.883 1.883 0 00-1.883 1.875v2.292a.417.417 0 00.416.416z",
      fill: "#333"
    }
  ),
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M16.38 11.174a5.415 5.415 0 105.416 5.415 5.423 5.423 0 00-5.415-5.415zm-2.207 4.09a.623.623 0 01.437-1.082.626.626 0 01.446.2l1.175 1.174a.208.208 0 00.3 0l1.174-1.175a.625.625 0 01.884.883l-1.175 1.175a.208.208 0 000 .3l1.174 1.174a.625.625 0 01-.201 1.021.616.616 0 01-.682-.137l-1.174-1.175a.21.21 0 00-.232-.047.21.21 0 00-.068.047l-1.175 1.175a.617.617 0 01-.883 0 .625.625 0 010-.884l1.175-1.174a.206.206 0 00.047-.232.206.206 0 00-.047-.068l-1.175-1.175z",
      fill: "#E63900"
    }
  )
);
export {
  e as default
};
